import { render, staticRenderFns } from "./shenDocumentDetail.vue?vue&type=template&id=52258d38&"
import script from "./shenDocumentDetail.vue?vue&type=script&lang=js&"
export * from "./shenDocumentDetail.vue?vue&type=script&lang=js&"
import style0 from "./shenDocumentDetail.vue?vue&type=style&index=0&id=52258d38&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports